import type { CommissionPayoutRunNode, CommissionReleaseBatchNode } from "../release/types";

export const commissionReleaseBatchFixtures: CommissionReleaseBatchNode[] = [
  {
    id: "commission-release-batch-exported",
    status: "EXPORTED",
    batchType: "AD_HOC",
    totalAmountCents: 350000,
    selectionCount: 2,
    lineCount: 2,
    requestedLineIds: ["commission-line-3", "commission-line-4"],
    exceptionCount: 0,
    depositFileKey: "corebridge/deposits/2026-03-18/commission-release-batch-exported.csv",
    payoutRunCount: 2,
    exportedAt: "2026-03-18T16:45:00Z",
    createdAt: "2026-03-18T16:30:00Z",
    program: { id: "commission-program-grp", name: "Golf Retirement Plus", slug: "grp" }
  },
  {
    id: "commission-release-batch-staged",
    status: "STAGED",
    batchType: "SCHEDULED_QUARTER_END",
    totalAmountCents: 150000,
    selectionCount: 1,
    lineCount: 1,
    requestedLineIds: ["commission-line-3", "commission-line-missing"],
    exceptionCount: 1,
    depositFileKey: null,
    payoutRunCount: 1,
    exportedAt: null,
    createdAt: "2026-03-01T12:00:00Z",
    program: { id: "commission-program-grp", name: "Golf Retirement Plus", slug: "grp" }
  }
];

export const commissionPayoutRunFixtures: Record<string, CommissionPayoutRunNode[]> = {
  "commission-release-batch-exported": [
    {
      id: "commission-payout-run-1",
      status: "EXPORTED",
      pgaId: "11223344",
      personDisplayName: "Alan Turing",
      person: { id: "person-alan", displayName: "Alan Turing", pgaId: "11223344" },
      periodSummary: {
        releaseBatchId: "commission-release-batch-exported",
        cutoff: "2026-03-18T16:30:00Z",
        lineCount: 1
      },
      lineItems: [
        {
          id: "commission-payout-line-item-1",
          amountCents: 200000,
          line: { id: "commission-line-3", amountCents: 200000 }
        }
      ],
      amountCents: 200000,
      lineCount: 1
    },
    {
      id: "commission-payout-run-2",
      status: "EXPORTED",
      pgaId: "55667788",
      personDisplayName: "Katherine Johnson",
      person: { id: "person-katherine", displayName: "Katherine Johnson", pgaId: "55667788" },
      periodSummary: {
        releaseBatchId: "commission-release-batch-exported",
        cutoff: "2026-03-18T16:30:00Z",
        lineCount: 1
      },
      lineItems: [
        {
          id: "commission-payout-line-item-2",
          amountCents: 150000,
          line: { id: "commission-line-4", amountCents: 150000 }
        }
      ],
      amountCents: 150000,
      lineCount: 1
    }
  ],
  "commission-release-batch-staged": [
    {
      id: "commission-payout-run-3",
      status: "PENDING",
      pgaId: "55667788",
      personDisplayName: "Katherine Johnson",
      person: { id: "person-katherine", displayName: "Katherine Johnson", pgaId: "55667788" },
      periodSummary: {
        releaseBatchId: "commission-release-batch-staged",
        cutoff: "2026-03-01T12:00:00Z",
        lineCount: 1
      },
      lineItems: [
        {
          id: "commission-payout-line-item-3",
          amountCents: 150000,
          line: { id: "commission-line-4", amountCents: 150000 }
        }
      ],
      amountCents: 150000,
      lineCount: 1
    }
  ]
};
